import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoginActionStatusService {
    constructor() {

    }
    public action: Subject<any> = new Subject();
}
